export const environment = {
  production: true,
  firebase:{
    apiKey: "AIzaSyBKHYGsT9uTznTz5FOFxqVxjXeXyyUxkH0",
    authDomain: "labrador-frontend.firebaseapp.com",
    databaseURL: "https://labrador-frontend.firebaseio.com",
    projectId: "labrador-frontend",
    storageBucket: "labrador-frontend.appspot.com",
    messagingSenderId: "917402468037"
  },
  websocketHost:'wss://beta.labrador.ai',
  // ENG-5968: through the microservices load balancer; split-out paths (payment callbacks, delivery tracking,
  // campaigns) reach their own services, everything else the same pre-prod backend.
  // Roll back: https://pre-prod-order-api-backend-628090102143.us-east1.run.app
  orderApiBackend: "https://api.beta.labrador.ai",
  accessToken: "e53e7a20711c270f8e890cfda68ef84319d94378",
  iTokenUrl: "https://fts.cardconnect.com",
  hostName: "https://order.beta.labrador.ai",
  referralPinvrf: "https://referbeta.pinvrf.com",
  gaTrackingId: "",
  posthogKey: "",
  posthogHost: "",
};
